import React, { useEffect } from 'react';
import { PurchaseToast } from './components/PurchaseToast';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { StopSearching } from './components/StopSearching';
import { ReadyToUse } from './components/ReadyToUse';
import { SystemSection } from './components/SystemSection';
import { ModulesSection } from './components/ModulesSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { BonusSection } from './components/BonusSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
interface AppProps {
  /** Show the rotating "just purchased" social-proof popup. */
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1777770560132644');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="d4xp3e9cy9cu">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1777770560132644&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="d3mi75km8lhi" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-off text-charcoal" data-id="element-2" data-mp="3glo0k8nplelx">
        <main data-id="element-3" data-mp="3bnmk7vho3te5">
          <Hero data-id="element-4" data-mp="3bo4kd37garrc" />
          <ProblemSection data-id="element-5" data-mp="3bkgss9lkgff9" />
          <StopSearching data-id="element-6" data-mp="3qbpon0g2ax0u" />
          <ReadyToUse data-id="element-7" data-mp="3qbzg6sgr9c8n" />
          <SystemSection data-id="element-8" data-mp="3qcin7e4vag7w" />
          <ModulesSection data-id="element-9" data-mp="3lkhg06mk3foq" />
          <PreviewCarousel data-id="element-10" data-mp="3lk7lq6uhamd8" />
          <BonusSection data-id="element-11" data-mp="3liwkoesf3spt" />
          <DifferentiatorSection data-id="element-12" data-mp="3limryjfzn7gf" />
          <Offer data-id="element-13" data-mp="2xud8vpa5sxsz" />
          <Guarantee data-id="element-14" data-mp="2xtv8cgggrxf9" />
          <Testimonials data-id="element-15" data-mp="2xt27tx83m45k" />
          <FAQ data-id="element-16" data-mp="2xsk3sef72ln3" />
          <FinalCTA data-id="element-17" data-mp="2sw1zffns0pba" />
        </main>
        <Footer data-id="element-18" data-mp="2sv0orcaoa4u3" />
      </div>

      {showPurchasePopup && <PurchaseToast data-id="element-19" data-mp="18drky0d87nfx" />}
    </>;
}